import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  LinearProgress,
  Tooltip
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  progress: {
    marginTop: theme.spacing(3)
  }
}));

const RateStatBox = props => {
  const { className, statType, currentStat, isReportLoading, tooltipText, ...rest } = props;

  const classes = useStyles();

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justify="space-between">
          <Grid item>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2">
              {statType}
            </Typography>
          </Grid>
          {!isReportLoading && <Grid item>
            <Typography variant="h3">
              {currentStat ? `${new Intl.NumberFormat().format(currentStat)}%`: '0%'} 
              <Tooltip
                title={tooltipText}>
                <InfoIcon style={{ marginLeft: '5px' }} />
              </Tooltip>
            </Typography>
          </Grid>}
        </Grid>
        {!isReportLoading && <LinearProgress
          className={classes.progress}
          value={currentStat ? parseInt(currentStat): 0}
          variant="determinate"
        />}
      </CardContent>
    </Card>
  );
};

RateStatBox.propTypes = {
  className: PropTypes.string
};

export default RateStatBox;
